import React from "react";
import './infoUser.css';
import { Row, Col, Container } from "reactstrap";
import Competences from '../../components/competences/competences';

import Curadoria from "../../assets/images/curadoria-info.png";


class InfoUser extends React.Component {

    render() {
        return (
            <div>
            <Row id="infoUser" className="bg-dark">
                <Col className="container-info">
                    <Container>
                        <h2 className="text-light"> Como Utilizar o Portal do NSC Escola</h2>
                        <p className="text-center">
                        <img src={Curadoria} alt="Logo Oficial do Enem" className="img-fluid img-curadoria"/>
                        </p>
                        <p>
                            Nesta Etapa atual nosso programa atende às Escolas de forma única, fazendo com que os trabalhos desenvolvidos em Sala de aula
                            sejam analisados por um time de Profissionais da Universidade Federal do Estado de Santa Catarina. Esta Curadoria é feita baseada
                            nos critérios do BNCC. 
                        </p>
                        <p>
                           O Professor, utilizando seu login e senha fornecido pela sua Escola, efetua seu login no Portal NSC Escola e juntamente com sua defesa,
                           realiza o Upload os trabalhos e produções feitas por suas turmas para o Portal NSC Escola.
                        </p>
                        <p>
                           Após o time de Elencados da UFSC receber e concluír a Curodaria das produções e arquivos recebidos, os mesmos serão publicados pela 
                           NSC Escola em seu Portal para estarem disponíveis para a Escola e seus responsáveis.
                        </p>                  
                    </Container>
                </Col>
            </Row>            
            <Competences />
            </div>
        );
    }
}

export default InfoUser;